import { Injectable } from '@angular/core'
import { ModalController } from '@ionic/angular/standalone'

import { LoginPage, LoginViewMode } from './login.page'

@Injectable({
	providedIn: 'root',
})
export class LoginModalService {
	constructor(private readonly modalController: ModalController) {}

	async open(mode: LoginViewMode = 'login') {
		const modal = await this.modalController.create({
			component: LoginPage,
			componentProps: { initialMode: mode },
			cssClass: 'login-auth-modal',
			backdropDismiss: true,
		})

		await modal.present()
		return modal.onDidDismiss()
	}
}
